import type { StructuredError } from './l3-types';

export class LabError extends Error {
  readonly structured: StructuredError;

  constructor(code: string, stage: string, message: string, recoverable = true) {
    super(message);
    this.name = 'LabError';
    this.structured = { code, stage, message, recoverable };
  }
}

export function asStructuredError(error: unknown, code: string, stage: string): StructuredError {
  if (error instanceof LabError) return error.structured;
  return {
    code,
    stage,
    recoverable: true,
    message: error instanceof Error ? error.message : String(error),
  };
}

export function throwIfAborted(signal: AbortSignal, stage: string): void {
  if (signal.aborted) throw new LabError('ABORTED', stage, 'Operation cancelled.');
}
